import { useState } from 'react'
import ProgramadosTable from './ProgramadosTable'
import ProgramadosFilters from './ProgramadosFilters'

export default function ProgramadosTableIndex({
  documents,
  query,
  setQuery,
  onEdit,
  onDeleteSuccess
}) {
  const [filters, setFilters] = useState({
    status: 'Todos',
    frequency: 'Todas',
    docType: 'Todos'
  })

  // Filtering Logic
  const filteredDocuments = documents.filter(doc => {
    // 1. Text Search (Query) - passed from parent
    if (query) {
      const lowerQuery = query.toLowerCase()
      const receiverName = (doc.receiver_data?.name || '').toLowerCase()
      const receiverTaxId = (doc.receiver_data?.tax_id || '').toLowerCase()
      const docDescription = (doc.dte_type_data?.description || '').toLowerCase()
      const freq = (doc.frequency_display || '').toLowerCase()
      const statusDisplay = (doc.status_display || '').toLowerCase()
      const statusRaw = (doc.status || '').toLowerCase()

      const matches =
        receiverName.includes(lowerQuery) ||
        receiverTaxId.includes(lowerQuery) ||
        docDescription.includes(lowerQuery) ||
        freq.includes(lowerQuery) ||
        statusDisplay.includes(lowerQuery) ||
        statusRaw.includes(lowerQuery)

      if (!matches) return false
    }

    // 2. Status Filter
    if (filters.status !== 'Todos') {
      const status = (doc.status_display || '').toLowerCase()
      const target =
        filters.status === 'Activos'
          ? 'activo'
          : filters.status === 'Inactivos'
            ? 'inactivo'
            : filters.status === 'Completados'
              ? 'completado'
              : filters.status.toLowerCase()

      if (status !== target) return false
    }

    // 3. Frequency Filter
    if (filters.frequency !== 'Todas') {
      const freq = (doc.frequency_display || '').toLowerCase()
      if (freq !== filters.frequency.toLowerCase()) return false
    }

    // 4. Document Type Filter
    if (filters.docType !== 'Todos') {
      const type = Number(doc.dte_type_data.code)
      const nationalCodes = [33, 34, 39, 46, 61, 80]

      if (filters.docType === 'Documentos Nacionales') {
        if (!nationalCodes.includes(type)) return false
      }

      if (filters.docType === 'Facturas de Exportación') {
        if (type !== 110) return false
      }

      if (filters.docType === 'Notas de Crédito de Exportación') {
        return false // Pendiente de implementación o códigos específicos
      }
    }

    return true
  })

  if (filteredDocuments.length === 0) {
    return (
      <div className='flex flex-col gap-4'>
        <ProgramadosFilters
          filters={filters}
          setFilters={setFilters}
          query={query}
          setQuery={setQuery}
        />
        <div className='p-12 text-center text-gray-500 border border-gray-200 rounded mt-4 bg-white'>
          No se encontraron documentos con los filtros seleccionados.
        </div>
      </div>
    )
  }

  return (
    <div className='flex flex-col gap-1'>
      <ProgramadosFilters
        filters={filters}
        setFilters={setFilters}
        query={query}
        setQuery={setQuery}
      />
      <ProgramadosTable
        documents={filteredDocuments}
        onEdit={onEdit}
        onDeleteSuccess={onDeleteSuccess}
      />
    </div>
  )
}
